import { genUniqueId } from "../utils";

// CREATE
export const CREATE_CIRCLE = "CREATE_CIRCLE";
export function createCircle(name) {
  return {
    type: CREATE_CIRCLE,
    payload: {
      id: genUniqueId(),
      name,
    },
  };
}

// REMOVE
export const DELETE_CIRCLE = "DELETE_CIRCLE";

export function deleteCircle(id) {
  return {
    type: DELETE_CIRCLE,
    id,
  };
}

// ADD HUMANS
export const ADD_HUMANS = "ADD_HUMANS";
export function addHumans(humanIds, circleId) {
  return {
    type: ADD_HUMANS,
    payload: {
      humanIds: humanIds,
      circleId: circleId,
    },
  };
}

// REMOVE HUMANS
export const REMOVE_HUMAN = "REMOVE_HUMAN";
export function removeHuman(humanId, circleId) {
  return {
    type: REMOVE_HUMAN,
    payload: {
      humanId: humanId,
      circleId: circleId,
    },
  };
}

// UPDATE
export const RENAME_CIRCLE = "RENAME_CIRCLE";

export function renameCircleTitle(circleId, name) {
  return {
    type: RENAME_CIRCLE,
    circleId,
    name,
  };
}
